const decodeBase64URLV815 = (value) => {
  const normalized = String(value || '')
    .replace(/-/g, '+')
    .replace(/_/g, '/');
  const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');
  const binary = window.atob(padded);
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1) {
    bytes[index] = binary.charCodeAt(index);
  }
  return bytes.buffer;
};

const encodeBase64URLV815 = (value) => {
  if (!value) return null;
  const bytes = new Uint8Array(value);
  let binary = '';
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return window
    .btoa(binary)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/g, '');
};

const credentialDescriptorsV815 = (items = []) =>
  items.map((item) => ({
    ...item,
    id: decodeBase64URLV815(item.id),
  }));

export const createPasskeyV815 = async (options) => {
  if (!window.PublicKeyCredential || !navigator.credentials) {
    throw new Error('此浏览器不支持 Passkey');
  }
  const publicKey = {
    ...options.publicKey,
    challenge: decodeBase64URLV815(options.publicKey.challenge),
    user: {
      ...options.publicKey.user,
      id: decodeBase64URLV815(options.publicKey.user.id),
    },
    excludeCredentials: credentialDescriptorsV815(
      options.publicKey.excludeCredentials
    ),
  };
  const credential = await navigator.credentials.create({ publicKey });
  return {
    id: credential.id,
    rawId: encodeBase64URLV815(credential.rawId),
    type: credential.type,
    authenticatorAttachment: credential.authenticatorAttachment,
    clientExtensionResults: credential.getClientExtensionResults(),
    response: {
      attestationObject: encodeBase64URLV815(
        credential.response.attestationObject
      ),
      clientDataJSON: encodeBase64URLV815(credential.response.clientDataJSON),
      transports: credential.response.getTransports
        ? credential.response.getTransports()
        : [],
    },
  };
};

export const getPasskeyV815 = async (options) => {
  if (!window.PublicKeyCredential || !navigator.credentials) {
    throw new Error('此浏览器不支持 Passkey');
  }
  const publicKey = {
    ...options.publicKey,
    challenge: decodeBase64URLV815(options.publicKey.challenge),
    allowCredentials: credentialDescriptorsV815(
      options.publicKey.allowCredentials
    ),
  };
  const credential = await navigator.credentials.get({ publicKey });
  return {
    id: credential.id,
    rawId: encodeBase64URLV815(credential.rawId),
    type: credential.type,
    authenticatorAttachment: credential.authenticatorAttachment,
    clientExtensionResults: credential.getClientExtensionResults(),
    response: {
      authenticatorData: encodeBase64URLV815(
        credential.response.authenticatorData
      ),
      clientDataJSON: encodeBase64URLV815(credential.response.clientDataJSON),
      signature: encodeBase64URLV815(credential.response.signature),
      userHandle: encodeBase64URLV815(credential.response.userHandle),
    },
  };
};
